const STORAGE_KEY = "auth_callback_error";

/**
 * Supabase appends `error`/`error_description` (occasionally `error_code`) to the redirect
 * URL when a magic-link verification fails (expired, already used/pre-fetched by an email
 * scanner, etc) -- in the hash for the implicit/verify-redirect flow, or the query string
 * for some PKCE failures. Our own routing (App.tsx's <Navigate to="/login" replace />)
 * replaces the whole location before Login.tsx ever mounts, silently discarding that error.
 *
 * Captured here, as a side effect at MODULE LOAD time -- imported first thing in main.tsx,
 * before React/React Router render anything -- and stashed in sessionStorage so Login can
 * show it regardless of how many redirects happen first.
 */
(function captureAuthCallbackError() {
  if (typeof window === "undefined") return;
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const search = new URLSearchParams(window.location.search);
  const description =
    hash.get("error_description") ?? search.get("error_description") ?? hash.get("error") ?? search.get("error");
  if (description) {
    try {
      sessionStorage.setItem(STORAGE_KEY, decodeURIComponent(description.replace(/\+/g, " ")));
    } catch {
      // sessionStorage can throw in a locked-down context (e.g. private browsing edge
      // cases); losing the error message is acceptable, crashing the app boot is not.
    }
  }
})();

export function consumeAuthCallbackError(): string | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    if (value) sessionStorage.removeItem(STORAGE_KEY);
    return value;
  } catch {
    return null;
  }
}
